import type { ProjectJson } from '@ironsight/types'

export default class Project {
  id: string
  name: string
  number: number
  ownerId: string
  created: string
  createdBy: string
  requestedJobCount: number
  assignedToServiceProviderJobCount: number
  scheduledJobCount: number
  activeJobCount: number
  pausedJobCount: number
  completedJobCount: number
  cancelledJobCount: number
  totalJobCount: number

  constructor(json: ProjectJson) {
    this.id = json.id
    this.name = json.name
    this.number = json.number
    this.ownerId = json.ownerId
    this.created = json.created
    this.createdBy = json.createdBy
    this.requestedJobCount = json.requestedJobCount
    this.assignedToServiceProviderJobCount = json.assignedToServiceProviderJobCount
    this.scheduledJobCount = json.scheduledJobCount
    this.activeJobCount = json.activeJobCount
    this.pausedJobCount = json.pausedJobCount
    this.completedJobCount = json.completedJobCount
    this.cancelledJobCount = json.cancelledJobCount
    this.totalJobCount = json.totalJobCount
  }

  get displayName(): string {
    return `${this.name} #${this.number}`
  }
}
